import React from 'react';
import {
	Container,
	ContainerGutter,
	ContainerPadding,
	ControlContainer,
	CTA,
	FullscreenButton,
	PlayButton,
	PlayButtonCenter,
	TimeDisplay,
	Timeline,
	Video,
	VolumeSlider,
	Text,
	AspectRatioContainer,
	Image,
	TokenTextAppearance,
	Richtext,
	TextAlignment,
} from '@volkswagen-onehub/components-core';
import styled from 'styled-components';
import { NovedadesItem } from '@esportal/portal-service';

const ContentWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
`;

const StyledContainer = styled(Container)`
	max-width: 1000px;
	width: 100%;

	@media (min-width: 1600px) {
		max-width: 1200px;
	}

	@media (min-width: 2560px) {
		max-width: 1400px;
	}
`;

interface NovedadesLayerContentProps {
	item: NovedadesItem;
	onCtaClick: () => void;
}

export const NovedadesLayerContent = ({ item, onCtaClick }: NovedadesLayerContentProps) => {
	return (
		<ContentWrapper className="video-layer-content-wrapper">
			<StyledContainer
				padding={{
					left: ContainerPadding.dynamic0150,
					right: ContainerPadding.dynamic0150,
				}}
				stretchContent
				horizontalAlign="center"
				gutter={ContainerGutter.dynamic0100}
				wrap="always"
			>
				{item.layer.videoUrl && (
					<Video src={item.layer.videoUrl}>
						<PlayButtonCenter playTitle="Play video" />
						<ControlContainer hideInitially>
							<PlayButton playTitle="Play video" pauseTitle="Pause video" />
							<Timeline />
							<TimeDisplay />
							<VolumeSlider muteTitle="Mute video" unmuteTitle="Unmute video" />
							<FullscreenButton openTitle="Open video in fullscreen" closeTitle="Close fullscreen" />
						</ControlContainer>
					</Video>
				)}

				{/* priorizamos videoUrl, si no, imageUrl */}
				{!item.layer.videoUrl && item.layer.imageUrl && (
					<AspectRatioContainer ratio="16:9">
						<Image
							src={item.layer.imageUrl}
							objectFit="cover"
							alt="novedades_layer_image"
							style={{
								borderRadius: '24px',
							}}
						/>
					</AspectRatioContainer>
				)}

				{/* mostramos solo el layer title si es diferente al card title */}
				{item.layer.title && item.layer.title !== item.card.title && (
					<Text textAlign={TextAlignment.center} appearance={TokenTextAppearance.headline400}>
						<Richtext dangerouslyParseRawHTML markdown={item.layer.title} />
					</Text>
				)}

				{item.layer.description && (
					<Text appearance={TokenTextAppearance.bigcopy100} textAlign={TextAlignment.center}>
						<Richtext dangerouslyParseRawHTML markdown={item.layer.description} />
					</Text>
				)}

				{item.layer.cta.src && (
					<Container horizontalAlign="center">
						<CTA tag="button" emphasis="nbab" onClick={onCtaClick}>
							{item.layer.cta.label ?? 'Descubre más'}
						</CTA>
					</Container>
				)}

				{item.layer.legal && (
					<Container
						horizontalAlign="center"
						padding={{
							top: ContainerPadding.dynamic0130,
						}}
					>
						<Text appearance={TokenTextAppearance.copy100}>
							<Richtext dangerouslyParseRawHTML markdown={item.layer.legal} />
						</Text>
					</Container>
				)}
			</StyledContainer>
		</ContentWrapper>
	);
};
